var happy = {
    USPhone: function (val) {
        return /^\(?(\d{3})\)?[\- ]?\d{3}[\- ]?\d{4}$/.test(val)
    },

    // matches mm/dd/yyyy (requires leading 0's (which may be a bit silly, what do you think?)
    date: function (val) {
        return /^(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12][0-9]|3[01])\/(?:\d{4})/.test(val);
    },

    email: function (val) {
        return /^(?:\w+\.?)*\w+@(?:\w+\.)+\w+$/.test(val);
    },

    minLength: function (val, length) {
        return val.length >= length;
    },

    minValue: function (val,minVal) {
        return val >= minVal;
    },

    maxLength: function (val, length) {
        return val.length <= length;
    },

    equalLength: function (val, length) {
        return val.length == length;
    },

    equal: function (val1, val2) {
        return (val1 == val2);
    },
    elemExists: function (val, selector) {
        return ($(selector).length > 0);
    },
    number: function (val) {
        return ($.isNumeric(val));
    },
    visibleDate: function (val, selector) {
        return GetDateTime(val) <= GetDateTime($(selector).val());
    },
    startDate: function (val, selector) {
        var ids = selector.split(';');
        var pStart = GetDateTime(val);
        var pEnd = GetDateTime($(ids[0]).val());

        return (pStart < pEnd);
    },
    endDate: function (val, selector) {
        var now = new Date();
        now.setMinutes(now.getMinutes() + 15);

        var pEnd = GetDateTime(val);
        var aEnd = GetDateTime($(selector).val());

        return (pEnd <= aEnd && pEnd >= now);
    },
    auctionId: function(val) {
        return (!isNaN(val)) && parseInt(val) > 0;
    },
    equalTo: function (val, selector) {
        return val == $(selector).val();
    },
    checkConditionalRequired: function (val, conditionalControl) {
        return val != '' || $(conditionalControl).val() == null || $(conditionalControl).val() == '';
    },

    //custom validation for auction inventory
    minValueCustom: function (val, minVal) {
        var a = $("#AuctionOptions").val() == 3;
        if ($("#AuctionOptions").val() == 3) {
            return val >= 2;
        } else {
            return val >= minVal;
        }
    }
};

window.happy = happy;

function GetDateTime(inputTime) {
    if (inputTime != undefined) {
        var t = inputTime.split(' ');

        var dateArr = t[0].split('-');
        var timeArr = t[1].split(':');

//    alert(parseInt(dateArr[2]) + ';' + parseInt(dateArr[1]) + ';' + parseInt(dateArr[0]) + ';' + parseInt(timeArr[0]) + ';' + parseInt(timeArr[1]));
        return new Date(parseInt(dateArr[2]), parseInt(dateArr[1])-1, parseInt(dateArr[0]), parseInt(timeArr[0]), parseInt(timeArr[1]), 0, 0);
    }
}

window.GetDateTime = GetDateTime;